<template>
  <div id="wangeditor">
    <div ref="editorElem" style="text-align: left"></div>
  </div>
</template>

<script>
import E from 'wangeditor'
import { indexOp, deleteOp, updateOp, showOp, addOp, uploadImg } from '../api/index'
import base from "../api/base.js";
export default {
  name: 'Editor',
  data() {
    return {
      editorContent: '',
      editor: null,
      url:base.apiURL,
    }
  },
  props: ['catchData', 'value'], //接收父组件的方法
  watch: {
    value(newVal) {
      this.setHtml(newVal)
    },
  },
  created() {},
  mounted() {
    const that = this

    this.editor = new E(this.$refs.editorElem)
    // this.editor.create()
    console.log(this.editor)
    //创建富文本实例
    this.editor.config.onchange = (html) => {
      // html  带P标签的文本
      // this.getText() 不带P标签的文本
      // console.log(html)
    //   html = this.getHtml()
      this.editorContent = html
      this.$emit('change')
      this.$emit('editor-input', html)
    }
    this.editor.config.zIndex = 1
    // 隐藏“网络图片”tab
    this.editor.config.showLinkImg = false
    this.editor.config.focus = false
    this.editor.config.uploadImgServer = '你的上传图片的接口'
    this.editor.config.uploadFileName = '你自定义的文件名'
    this.editor.config.uploadImgHeaders = {
      Accept: '*/*',
      // 'Authorization':'Bearer ' + token    //头部token
    }
    this.editor.config.menus = [
      //菜单配置
      'head',
      'bold',
      'fontSize',
      'fontName',
      'italic',
      'underline',
      'strikeThrough',
      'indent',
      'lineHeight',
      'foreColor',
      'backColor',
      'link',
      'list',
      'justify',
      'quote',
      'emoticon',
      'image',
      // 'video',
      'table',
      'code',
      'splitLine',
      'undo',
      'redo',
    ]
    //下面是最重要的的方法
    this.editor.config.customUploadImg = function (files, insert) {
      console.log('图片上传', files)
      const file = files[0]
      const extName = that.getExtName(file.name)
      var formData = new FormData()
      formData.append('file', file)
      uploadImg(formData).then(res=>{
        const imgUrl = that.url + res.data.url
        insert(imgUrl)
      })
    }
    this.editor.create()
    if (this.value) {
      this.setHtml(this.value)
    }
  },
  methods: {
    // 获取内容(html)
    getHtml() {
      return this.editor.txt.html()
    },
    // 获取内容(纯文本)
    getText() {
      return this.editor.txt.text()
    },
    // 设置内容(html)
    setHtml(text) {
      this.editor.txt.html(text)
    },
    // 追加内容(html)
    appendHtml(text) {
      this.editor.txt.append(text)
    },
    // 清空内容
    clear() {
      this.editor.txt.clear()
    },
    /**
     * 获取后缀名
     */
    getExtName(fileName) {
      let index = fileName.lastIndexOf('.')
      if (index > -1) {
        return fileName.substring(index + 1)
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped  lang="less">
.w-e-toolbar {
  flex-wrap: wrap !important;
}
.w-e-text {
  p {
    white-space: normal !important;
  }
}
</style>
